export default __webpack_public_path__ + "static/media/AcIconOff.1ffa29db.svg";